/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import Translate from '../../i18n/Translate';

import { AuthContext } from '../../contexts/AuthProvider';

import SubscribeForm from './components/SubscribeForm';
import SocialMedia from '../../components/icons/SocialMedia';
import Logo from '../../assets/images/static/Logo.svg';
import Phone from '../../assets/images/icons/Footer_phone.svg';
import Mail from '../../assets/images/icons/Footer_mail.svg';
import Location from '../../assets/images/icons/Footer_location.svg';

import color from '../../assets/scss/variables/colors.module.scss';
import PrivateLink from '../../components/PrivateLink';

const DOMAIN = process.env.REACT_APP_DOMAIN;

const Footer = () => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();

  // const email = 'pepe@gmail.com';
  const { colorPrimario, colorSecundario } = color;

  const aereosUrl = process.env.REACT_APP_AEREOS_URL;
  const aereosPass = process.env.REACT_APP_AEREOS_PASS;
  const disneyUrl = process.env.REACT_APP_DISNEY_URL;

  return (
    <footer className='footer'>
      <div className='footer__container'>
        <div className='footer__container__column1'>
          <img src={Logo} alt='Tower Partners Logo' title='Tower Partners Logo' />

          <p>
            <Translate langkey='footer.column1.copy' />
          </p>

          <div className='footer__container__column1__info'>
            <a href='#' target='_blank' rel='noreferrer'>
              <img loading='auto' src={Location} alt='Location' />
              <span>
                <Translate langkey='footer.column1.address' />
              </span>
            </a>

            <a href='tel:+541152177400' target='_blank' rel='noreferrer'>
              <img loading='auto' src={Phone} alt='Phone' />
              <Translate langkey='footer.column1.phone' />
            </a>

            <a href='mailto:info@towertravel.com.ar' target='_blank' rel='noreferrer'>
              <img loading='auto' src={Mail} alt='Mail' />
              <Translate langkey='footer.column1.email' />
            </a>
          </div>

          <div className='footer__container__column1__social'>
            <SocialMedia fill={colorPrimario} background={colorSecundario} />
          </div>
        </div>

        <div className='footer__container__column2'>
          <h3>
            <Translate langkey='footer.column2.title' />
          </h3>

          <ul>
            <li>
              <NavLink exact to={t('routes.home')}>
                <Translate langkey='links.option0' />
              </NavLink>
            </li>
            {/* Aereos */}
            <li>
              <PrivateLink
                href={`${aereosUrl}`}
                isAuthenticated={user.isAuthenticated}
              >
                <Translate langkey='links.option1' />
              </PrivateLink>
            </li>
            {/* Cruceros */}
            <li>
              <NavLink to={t('routes.cruise')}>
                <Translate langkey='links.option2' />
              </NavLink>
            </li>
            {/* Circuitos */}
            <li>
              <NavLink to={t('routes.circuits')}>
                <Translate langkey='links.option3' />
              </NavLink>
            </li>
            {/* Metodos de pago */}
            <li>
              <a href={t('routes.paymentmethods')} target='_blank' rel='noreferrer'>
                <Translate langkey='links.option4.title' />
              </a>
            </li>
            {/* Disney */}
            <li>
              <PrivateLink
                href={`${disneyUrl}975`}
                isAuthenticated={user.isAuthenticated}
              >
                <Translate langkey='links.option5.title' />
              </PrivateLink>
            </li>
            {/* Flyers */}
            <li>
              <NavLink to={t('routes.flyers')}>
                <Translate langkey='links.option6' />
              </NavLink>
            </li>
            {/* Bodas */}
            <li>
              <NavLink to={`${t('routes.weddings')}`}>
                <Translate langkey='links.option7.link2' />
              </NavLink>
            </li>
            {/* Shine 15 */}
            <li>
              <a href={`${t('routes.fifteenyears')}`} rel='noreferrer' target='_blank'>
                <Translate langkey='links.option7.link5' />
              </a>
            </li>
          </ul>
        </div>

        <div className='footer__container__column3'>
          <h3>
            <Translate langkey='footer.column3.title' />
          </h3>

          <ul>
            <li>
              <a
                href={t('routes.contact', { domain: DOMAIN })}
                target='_blank'
                rel='noreferrer'
              >
                <Translate langkey='footer.column3.links.link1' />
              </a>
            </li>

            {/* <li>
							<Link to='/'>
								<Translate langkey='footer.column3.links.link2' />
							</Link>
						</li> */}
          </ul>
        </div>

        <div className='footer__container__column4'>
          <h3>
            <Translate langkey='footer.column4.title' />
          </h3>

          <p>
            <Translate langkey='footer.column4.copy' />
          </p>

          <div className='footer__container__column4-input'>
            <SubscribeForm />
          </div>
        </div>

        <div className='footer__container__column5'>
          <a
            target='_blank'
            href='https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcwODQ3NDI4OV1bdGlwb2RvbWljaWxpbz0wXVtzZWN1ZW5jaWE9MF1bdXJsPWh0dHA6Ly93d3cudG93ZXJ0cmF2ZWwuY29tLmFyL119'
            rel='noreferrer'
          >
            <img
              src='https://www.towertravel.com.ar/web/assets/img/DataFIscal-QR.png'
              alt='logo'
            />
          </a>

          <div>
            <p>
              <Translate langkey='footer.column5.title' />
            </p>
            <p>
              <Translate langkey='footer.column5.copy' />
            </p>
            <br />
            <p>
              <Translate langkey='footer.column5.copy2' />
            </p>
          </div>
        </div>

        <div className='footer__container__footer'>
          <p>
            <Translate langkey='footer.footer.copy1' />
          </p>
          <p>
            <Translate langkey='footer.footer.copy2' />{' '}
            <a
              href='https://bigsurbranding.com/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <span>Big Sur Branding</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
